import dayjs from "dayjs";
import { DateRangeAction, DateRangeState } from "./types";

export const initialState: DateRangeState = {
  isYearly: false,
  startDate: dayjs().subtract(30, "day").format("YYYY-MM-DD"),
  endDate: dayjs().format("YYYY-MM-DD"),
  fromDate: null,
  toDate: null,
  view: "monthly",
};

// Manages date range filter state transitions for the audit log view (monthly, yearly, custom range).
export const dateRangeReducer = (
  state: DateRangeState,
  action: DateRangeAction,
): DateRangeState => {
  switch (action.type) {
    case "SET_YEARLY": {
      const { isYearly, period } = action.payload;
      return {
        ...state,
        isYearly,
        view: isYearly ? "yearly" : "monthly",
        startDate: isYearly
          ? period.startOf("year").format("YYYY-MM-DD")
          : `${period.format("YYYY-MM")}-01`,
        endDate: isYearly
          ? period.endOf("year").format("YYYY-MM-DD")
          : `${period.format("YYYY-MM")}-${period.daysInMonth()}`,
      };
    }
    case "SET_FROM_DATE":
      return {
        ...state,
        fromDate: action.payload.value,
        view: "daterange",
        startDate: action.payload.value,
      };
    case "SET_TO_DATE":
      return {
        ...state,
        toDate: action.payload.value,
        view: "daterange",
        endDate: action.payload.value,
      };
    case "SET_START_AND_END_DATES":
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
      };
    case "CLEAR_DATES":
      return {
        ...state,
        fromDate: null,
        toDate: null,
        startDate: dayjs().format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
        isYearly: false,
        view: "monthly",
      };
    default:
      return state;
  }
};
